import React from "react";
import classNames from "classnames";

import { TabProps } from ".";

interface TabsProps {
  activeTab: string;
  setActiveTab: (name: string) => void;
  tabs: ReadonlyArray<TabProps>;
  theme?: string;
}

const Tabs: React.FC<TabsProps> = ({ activeTab, setActiveTab, tabs, theme }: TabsProps): JSX.Element => {
  return (
    <div className="caprx-tabs-container-list">
      {tabs.map(({ name, onTabClick }) => {
        const handleClick = (): void => {
          if (onTabClick) onTabClick();
          setActiveTab(name);
        };

        // handler to recognize when user presses enter
        const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>): void => {
          if (e.key === "Enter") {
            handleClick();
          }
        };

        let tabClass = "caprx-tabs-container-tab";

        if (theme === "purple") {
          tabClass = classNames(tabClass, "caprx-tabs-container-tab-purple");
        }

        if (activeTab === name) {
          tabClass = classNames(tabClass, "caprx-tabs-container-tab-active");
        }

        return (
          <div key={name} className={tabClass} onClick={handleClick} tabIndex={0} onKeyPress={handleKeyPress} data-testid={`caprx-tabs-container-tab-${name}`}>
            {name}
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
